import {
  SelectDropDownConfig,
  VueMultiselectProperties,
  VueMultiselectPropertiesParams
} from '@/models/select-dropdown';
export default class SelectDropDownFieldUtils {
  static limitTextDefault(param: any) {
    return `and ${param} other`;
  }

  static keysForTranslate = [
    'placeholder',
    'tagPlaceholder',
    'selectLabel',
    'selectGroupLabel',
    'deselectLabel',
    'deselectGroupLabel'
  ];

  static getVueMultiselectProperties({
    clearOnSelect,
    allowEmpty,
    name
  }: VueMultiselectPropertiesParams): VueMultiselectProperties {
    return {
      label: 'label',
      value: 'value',
      multiple: false,
      searchable: true,
      taggable: false,
      name,
      limit: 99999,
      tabindex: 0,
      clearOnSelect,
      hideSelected: false,
      allowEmpty,
      resetAfter: false,
      closeOnSelect: true,
      tagPosition: 'top',
      optionsLimit: 1000,
      groupSelect: false,
      blockKeys: [],
      internalSearch: false,
      preserveSearch: true,
      preselectFirst: false,
      showLabels: true,
      limitText: SelectDropDownFieldUtils.limitTextDefault,
      maxHeight: 300,
      openDirection: 'bottom',
      showNoResults: true,
      showPointer: true,
      optionHeight: 40,
      placeholder: 'placeholder',
      tagPlaceholder: 'tagPlaceholder',
      selectLabel: 'selectLabel',
      selectGroupLabel: 'selectGroupLabel',
      deselectLabel: 'deselectLabel',
      deselectGroupLabel: 'deselectGroupLabel'
    };
  }

  static getSelectdropdownPropertiesDefault(): SelectDropDownConfig {
    return {
      debounceTime: 400,
      translateKey: 'multiselect',
      clearOnSelect: false,
      allowEmpty: false,
      name: 'select_dropdown',
      useSearchIcon: false,
      maxlengthInput: '250',
      searchable: true
    };
  }
}
